import React from 'react';
import {useIntl} from 'react-intl';

export const LiteDeployments = () => {
  const intl = useIntl();
  return (
    <div>
      <p>{intl.formatMessage({id: 'studioLite.deployments.1'})}</p>
      <p>
        {intl.formatMessage(
          {id: 'studioLite.deployments.2'},
          {
            learnLink: (
              <a
                href="https://www.blaize.com/products/ai-studio/#deployment"
                target="_blank"
                rel="noreferrer"
              >
                here
              </a>
            ),
          }
        )}
      </p>
    </div>
  );
};
